import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProposalSendBack from '../../../widgets/proposalRevise/ProposalSendBack'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getReviewerFeedback } from '../../../redux/actions/reviewerFeedback'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ReviewerSendBack from '../../../widgets/proposalApproveReviewerRevise/ReviewerSendBack'

export default function ApproveReviewerRevise() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getReviewerFeedback(proposalId)
      console.log('call api => ', _schema)

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // const projectId = '9BE3B891-FD65-416B-8459-7AD624B5D3F2'
    console.log('load ProposalRevise proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema.forms.revise && (
            <ReviewerSendBack id={schema.projectReviewId} schema={schema.forms.revise} />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
